<template>
	<v-container>
		<v-layout align-center justify-center row>
			<v-flex xs12 md4>
				<v-form ref="formRecuperarSenha" @submit.prevent="recuperarSenha">
					<v-card class="elevation-1">
						<v-toolbar flat dark color="primary">
							<v-toolbar-title>Recuperar Senha</v-toolbar-title>
							<v-spacer />
						</v-toolbar>
						<v-card-text>
							<v-form-creator :schema="schema" :root="form" />
						</v-card-text>
						<v-card-actions class="px-3 pb-3">
							<v-spacer />
							<v-btn type="submit" color="primary">Confirmar</v-btn>
							<v-spacer />
						</v-card-actions>
					</v-card>
				</v-form>
			</v-flex>
		</v-layout>

		<v-loading :show="loading" message="Processando" />
	</v-container>
</template>

<script>
	import FormModel from '@/models/form';
	import VFormCreator from '@/components/formCreator';
	import VLoading from '@/components/loading';

	export default {
		components: { VFormCreator, VLoading },

		data() {
			return {
				form: new FormModel({
					cpf: null,
					codigoRecuperacaoSenha: null,
					novaSenha: null,
					confirmarSenha: null
				}),
				loading: false,
				nova: new FormModel({
					id: null,
					tokenHash: null,
					novaSenha: null
				})
			};
		},

		computed: {
			schema() {
				let { required, cpf, minlength, maxlength } = this.$rules;

				return [
					{
						label: 'CPF',
						model: 'cpf',
						mask: '###########',
						cols: { xs12: true },
						rules: [required, cpf]
					},
					{
						label: 'Código de recuperação',
						model: 'codigoRecuperacaoSenha',
						mask: 'AAAA-####-AAAA-####',
						cols: { xs12: true },
						returnMaskedValue: true,
						rules: [required]
					},
					{
						label: 'Nova Senha',
						model: 'novaSenha',
						type: 'password',
						cols: { xs6: true },
						class: { 'mr-2': true },
						rules: [required, minlength(6), maxlength(20)]
					},
					{
						label: 'Confirme a senha',
						model: 'confirmarSenha',
						type: 'password',
						cols: { xs6: true },
						rules: [required, v => this.form.novaSenha === v || 'As senhas não são iguais']
					}
				];
			}
		},

		methods: {
			async recuperarSenha() {
				if (this.$refs.formRecuperarSenha.validate()) {
					try {
						this.loading = true;

						var response = await this.form.save('/recuperacaoSenha/solicitarToken');
						this.nova.tokenHash = response.data.tokenHash;
						this.nova.id = response.data.id;

						if(this.nova.tokenHash) {
							this.nova.novaSenha = this.form.novaSenha;
							await this.nova.save('/recuperacaoSenha/alterarSenha');
						}

						this.$router.push('/');

						this.$store.$emit('show-message', {
							message: 'Senha alterada com sucesso!',
							timeout: 0,
							color: 'success'
						});
					} catch ({ data: { message } }) {
						if (message) {
							this.$store.$emit('show-message', { message, timeout: 5000, color: 'danger' });
						}
					} finally {
						this.loading = false;
					}
				}
			}
		}
	};
</script>